import * as React from 'react';

import { IconButton } from '@coursera/cds-core';

import CurriculumEnrollmentWarningModal from 'bundles/internal-enterprise/components/CurriculumEnrollmentWarningModal';

type Props = {
  s12n: { id: string; name: string; slug: string };
  enrolled: boolean;
  programId: string;
  userId: string;
};

type State = {
  showEnrollModal: boolean;
};

class S12nRow extends React.Component<Props, State> {
  state = {
    showEnrollModal: false,
  };

  openEnrollModal = () => {
    this.setState({ showEnrollModal: true });
  };

  closeEnrollModal = () => {
    this.setState({ showEnrollModal: false });
  };

  render() {
    const { s12n, enrolled, programId, userId } = this.props;
    return (
      <div className="row">
        <div className="table-cell col-xs-3">{s12n.name}</div>
        <div className="table-cell col-xs-3">{s12n.slug}</div>
        <div className="table-cell col-xs-3">{s12n.id}</div>
        <div className="table-cell col-xs-2">{enrolled ? 'ENROLLED' : 'NOT ENROLLED'}</div>
        <div className="table-cell col-xs-1">
          {!enrolled && (
            <IconButton
              intent="add"
              tooltip="Enroll in Specialization"
              variant="ghost"
              onClick={this.openEnrollModal}
            />
          )}
        </div>
        {this.state.showEnrollModal && (
          <CurriculumEnrollmentWarningModal
            onClosed={this.closeEnrollModal}
            enrollType="enrollInS12n"
            programId={programId}
            item={s12n}
            userId={userId}
          />
        )}
      </div>
    );
  }
}

export default S12nRow;
